import { createFileRoute, redirect } from '@tanstack/react-router';

/** Rota antiga (Integracao ERP): leva para a pagina do Protheus dentro de Integracoes. */
export const Route = createFileRoute('/_app/configuracoes/erp')({
  beforeLoad: () => {
    throw redirect({ to: '/configuracoes/integracoes/protheus' });
  },
});
